import { ControlButton, Edge, useReactFlow } from "@xyflow/react"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import { useKeymap } from "@features/keymap/useKeymap"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { MinusIcon } from "@components/Icons/Minus"
import { shortcuts } from "@features/keymap/shortcuts"

export const ZoomOutButton = () => {
  const reactFlowInstance = useReactFlow<AppNode, Edge<EdgeData>>()
  const keymap = useKeymap()

  const handleZoomOut = () => reactFlowInstance.zoomOut()

  return (
    <>
      <KeyBinding bind={shortcuts["zoom-out"]} onKeyDown={handleZoomOut} allowRepeat />
      <ControlButton
        data-testid="graph-controls-zoom-out-btn"
        onClick={handleZoomOut}
        title={keymap.getKeymaps().byId.get("zoom-out")?.desc}
      >
        <MinusIcon />
      </ControlButton>
    </>
  )
}
